import loaderGif from "images/loader.gif";

export default function OverlayLoader({ style }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed", // Position it fixed
        top: 0, // From the top
        left: 0, // From the left
        width: "100%", // Full width
        height: "100%", // Full height
        backgroundColor: "rgba(255, 255, 255, 0.5)", // Semi-transparent background
        zIndex: 9999, // Make sure it's on top of other elements
        ...style,
      }}
    >
      <img src={loaderGif} alt="loading..." />
    </div>
  );
}
